<template>
  <section>
    <div class="container">
      <div class="row section-title justify-content-center text-center">
        <div class="col-md-9 col-lg-8 col-xl-7">
          <div class="mb-5 mt-4">
            <img src="assets/img/illustrations/success-06.svg" alt height="200" />
          </div>
          <h1 class="display-4">Order Berhasil</h1>
          <div>
            <p>
              We have just sent further instructions for activating your account to
              <strong>dimasrakas@gmail.com</strong>
            </p>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
            
            <router-link to="/" class="btn btn-outline-dark order-lg-3 mr-3" tag="a"> <i class="fas fa-long-arrow-alt-left"></i> Kembali ke beranda </router-link>
            <a href="https://api.whatsapp.com/send?phone=6281252081581&text=Halo%20Rivaldy%20Setiawan%2C%20%0ASaya%20Dimas%20Raka%20Septiawan.%20Saya%20sudah%20melakukan%20pembayaran%20atas%20%2AOpen%20P.O%20oleh-oleh%20express%20khas%20Bali%2A.%20dengan%20rincian%20pemesanan%20sebagai%20berikut%20%3A%0A%0A1.%20Soto%20Ayam%20Lamongan%20Cak%20Har%20Surabaya%20%3A%20Rp%2015%2C000%20x%208%20Pcs%20%3D%20Rp%20120%2C000%0A%0A%2AGRAND%20TOTAL%20%3A%20Rp%20120%2C000%2A%0A%0ABerikut%20adalah%20bukti%20transfernya%0A%0A_Supported%20by%20https%3A%2F%2Fbukapo.id_%0A_Semua%20orang%20bisa%20dagang%2C%20Semua%20orang%20bisa%20menikmati_" target="_blank" class="btn btn-success"> <i class="fab fa-whatsapp"></i> Konfirmasi Pembayaran vis WhatApps</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "OrderConfirmation"
};
</script>